import $axios from "@/helpers/axios-helper";
import { service_paths } from "@/constants/Services";
const state = () => ({
  id_device: null,
  notify: {
    total: 0,
    new_notification: {}
  }
});
const getters = {
  newNotification: state => state.notify.new_notification,
  idDevice: state => state.id_device,
  totalNotify: state => state.notify.total
};

const actions = {
  async FetchTotalNotify({ commit }, userId) {
    try {
      const path = `${service_paths.notifications}/user/${userId}`;
      const res = await $axios.get(
        path,
        { un_read: true },
        undefined,
        undefined,
        undefined,
        undefined,
        false,
        false
      );

      if (res) {
        commit("setNotifyTotal", res.data.total);
        return true;
      }
    } catch (error) {
      throw error;
    }
  }
};

const mutations = {
  setIdDevice(state, idDevice) {
    state.id_device = idDevice;
  },

  setNotifyTotal(state, total) {
    state.notify.total = total;
  },

  increaseNotifyTotal(state) {
    state.notify.total++;
  },
  decreaseNotifyTotal(state) {
    state.notify.total--;
  },
  resetTotalNotify(state) {
    state.notify.total = 0;
  },
  clearNotifyTotal(state) {
    state.notify.total = 0;
    state.id_device = null;
  },

  setNewNotification(state, notification) {
    state.notify.new_notification = notification;
  }
};

export default { namespaced: true, state, getters, mutations, actions };
